type LogLevel = 'info' | 'warn' | 'error'

type LogContext = Record<string, unknown>

type SerializedError = {
  name: string
  message: string
  stack?: string
}

function serializeError(error: unknown): SerializedError | unknown {
  if (error instanceof Error) {
    return {
      name: error.name,
      message: error.message,
      stack: error.stack,
    }
  }

  return error
}

function normalizeContext(context: LogContext): LogContext {
  const normalized: LogContext = {}

  for (const [key, value] of Object.entries(context)) {
    if (value === undefined) continue
    normalized[key] = key.toLowerCase().includes('error') ? serializeError(value) : value
  }

  return normalized
}

function writeLog(level: LogLevel, event: string, context: LogContext = {}) {
  const payload = {
    ts: new Date().toISOString(),
    level,
    event,
    ...normalizeContext(context),
  }

  const line = JSON.stringify(payload)
  if (level === 'error') {
    console.error(line)
    return
  }

  if (level === 'warn') {
    console.warn(line)
    return
  }

  console.info(line)
}

export function logInfo(event: string, context: LogContext = {}) {
  writeLog('info', event, context)
}

export function logWarn(event: string, context: LogContext = {}) {
  writeLog('warn', event, context)
}

export function logError(event: string, context: LogContext = {}) {
  writeLog('error', event, context)
}
